import { render, staticRenderFns } from "./OrderDetailHistory.vue?vue&type=template&id=5bc9617b&scoped=true&"
import script from "./OrderDetailHistory.vue?vue&type=script&lang=js&"
export * from "./OrderDetailHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailHistory.vue?vue&type=style&index=0&id=5bc9617b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9617b",
  null
  
)

export default component.exports